<script>
export default {
    filters: {
        week: (item, lang) => {
            switch (lang) {
            case 'en':
                return {0: 'Su', 1: 'Mo', 2: 'Tu', 3: 'We', 4: 'Th', 5: 'Fr', 6: 'Sa'}[item]
            case 'ch':
                return {0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六'}[item]
            case 'jp':
                return {0: '日', 1: '月', 2: '火', 3: '水', 4: '木', 5: '金', 6: '土'}[item]
            default:
                return item
            }
        },
        month: (item, lang) => {
            switch (lang) {
            case 'en':
                return {
                    1: 'Jan',
                    2: 'Feb',
                    3: 'Mar',
                    4: 'Apr',
                    5: 'May',
                    6: 'Jun',
                    7: 'Jul',
                    8: 'Aug',
                    9: 'Sep',
                    10: 'Oct',
                    11: 'Nov',
                    12: 'Dec'
                }[item]
            case 'ch':
                return {
                    1: '一',
                    2: '二',
                    3: '三',
                    4: '四',
                    5: '五',
                    6: '六',
                    7: '七',
                    8: '八',
                    9: '九',
                    10: '十',
                    11: '十一',
                    12: '十二'
                }[item]
            case 'jp':
                return {
                    1: '1月',
                    2: '2月',
                    3: '3月',
                    4: '4月',
                    5: '5月',
                    6: '6月',
                    7: '7月',
                    8: '8月',
                    9: '9月',
                    10: '10月',
                    11: '11月',
                    12: '12月'
                }[item]
            default:
                return item
            }
        }
    },
    props: {
        language: {default: 'jp'},
        min: {default: '1970-01-01'},
        max: {default: '3016-01-01'},
        value: {
            type: [String, Array],
            default: ''
        },
        range: {
            type: Boolean,
            default: false
        },
        gameSchedule: {},
        inputDate: '',
        defaultVsTeamFull: '',
        playerTeam: ''
    },
    data() {
        let now = new Date()
        return {
            showCancel: false,
            panelState: false,
            panelType: 'date',
            coordinates: {},
            year: now.getFullYear(),
            month: now.getMonth(),
            date: now.getDate(),
            tmpYear: null,
            tmpMonth: null,
            // range===falseで選択されている年月日
            selectedYear: null,
            selectedMonth: null,
            selectedDate: null,
            // tmpStartYear: now.getFullYear(),
            // tmpStartMonth: now.getMonth(),
            tmpStartYear: this.tmpYear,
            tmpStartMonth: this.tmpMonth,
            tmpStartDate: now.getDate(),
            // tmpEndYear: now.getFullYear(),
            // tmpEndMonth: now.getMonth(),
            tmpEndYear: this.tmpYear,
            tmpEndMonth: this.tmpMonth,
            tmpEndDate: now.getDate(),
            minYear: Number,
            minMonth: Number,
            minDate: Number,
            maxYear: Number,
            maxMonth: Number,
            maxDate: Number,
            yearList: Array.from({length: 12}, (value, index) => new Date().getFullYear() + index),
            monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            weekList: [0, 1, 2, 3, 4, 5, 6],
            rangeStart: false,
            messageModalShow: false,
            message: '',
            vsTeam: ''
        }
    },
    computed: {
        dateList() {
            let that = this
            let currentMonthLength = new Date(this.tmpYear, this.tmpMonth + 1, 0).getDate()
            let dateList = Array.from({length: currentMonthLength}, (val, index) => {
                return {
                    currentMonth: true,
                    value: index + 1
                }
            })
            // 自チーム取得（ホーム試合下線用）
            let userAccount = (this.$ls.get('userAccount'))
            let my_team = Object.assign({}, userAccount).my_team

            for (let i = 0, len = dateList.length; i < len; i++) {
                let monthStr = ('00' + (this.tmpMonth + 1)).slice(-2)
                let dateStr = ('00' + dateList[i].value).slice(-2)
                let yyyymmddStr = this.tmpYear + '-' + monthStr + '-' + dateStr

                Object.keys(this.gameSchedule).forEach(function (key) {
                    if (Number(key) === that.tmpYear) {
                        let d = that.gameSchedule[that.tmpYear]
                        for (let i2 = 0, len2 = d.length; i2 < len2; i2++) {
                            if (d[i2].date === yyyymmddStr) {
                                // 自チームのホーム試合
                                d[i2].is_home_match = (that.playerTeam === d[i2].hometeam_id)

                                if (dateList[i].gameList === undefined) {
                                    dateList[i].gameList = [].concat(d[i2])
                                } else {
                                    dateList[i].gameList.push(d[i2])
                                }
                            }
                        }
                    }
                })
            }
            let startDay = new Date(this.year, this.tmpMonth, 1).getDay()
            let previousMongthLength = new Date(this.year, this.tmpMonth, 0).getDate()
            for (let i = 0, len = startDay; i < len; i++) {
                dateList = [{previousMonth: true, value: previousMongthLength - i}].concat(dateList)
            }
            for (let i = dateList.length, item = 1; i < 42; i++, item++) {
                dateList[dateList.length] = {nextMonth: true, value: item}
            }
            return dateList
        }
    },
    watch: {
        inputDate(v) {
            if (!this.range) {
                let dateStr = v.replace('年', '-').replace('月', '-').replace('日', '')
                let simpleGameList = []
                // 最小、最大以外を単純な配列に整形
                Object.keys(this.gameSchedule).forEach(function (key) {
                    if (key !== 'minDate' && key !== 'maxDate') {
                        this.gameSchedule[key].forEach(function (list) {
                            simpleGameList.push(list)
                        })
                    }
                }.bind(this))
                simpleGameList.forEach(function (d) {
                    if (dateStr === d.date) {
                        if (d.level === 'Bullpen') {
                            this.vsTeam = d.stadium
                        } else {
                            this.vsTeam = d.vsTeam + '戦'
                        }
                    }
                }.bind(this))
            }
        },
        min(v) {
            let minArr = v.split('-')
            this.minYear = Number(minArr[0])
            this.minMonth = Number(minArr[1])
            this.minDate = Number(minArr[2])
        },
        max(v) {
            let maxArr = v.split('-')
            this.maxYear = Number(maxArr[0])
            this.maxMonth = Number(maxArr[1])
            this.maxDate = Number(maxArr[2])
        },
        range(newVal, oldVal) {
            if (newVal === oldVal) return
            if (newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'String') {
                this.$emit('input', ['', ''])
            }
            if (!newVal && Object.prototype.toString.call(this.value).slice(8, -1) === 'Array') {
                this.$emit('input', '')
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            // if (this.$el.parentNode.offsetWidth + this.$el.parentNode.offsetLeft - this.$el.offsetLeft <= 300) {
            //   this.coordinates = {right: '0', top: `${window.getComputedStyle(this.$el.children[0]).offsetHeight + 4}px`}
            // } else {
            //   this.coordinates = {left: '0', top: `${window.getComputedStyle(this.$el.children[0]).offsetHeight + 4}px`}
            // }
            let minArr = this.min.split('-')
            this.minYear = Number(minArr[0])
            this.minMonth = Number(minArr[1])
            this.minDate = Number(minArr[2])
            let maxArr = this.max.split('-')
            this.maxYear = Number(maxArr[0])
            this.maxMonth = Number(maxArr[1])
            this.maxDate = Number(maxArr[2])

            if (this.range) {
                if (Object.prototype.toString.call(this.value).slice(8, -1) !== 'Array') {
                    throw new Error('Binding value must be an array in range mode.')
                }
                if (this.value.length) {
                    let rangeStart = this.value[0].split('-')
                    let rangeEnd = this.value[1].split('-')
                    this.tmpStartYear = Number(rangeStart[0])
                    this.tmpStartMonth = Number(rangeStart[1]) - 1
                    this.tmpStartDate = Number(rangeStart[2])
                    this.tmpEndYear = Number(rangeEnd[0])
                    this.tmpEndMonth = Number(rangeEnd[1]) - 1
                    this.tmpEndDate = Number(rangeEnd[2])
                } else {
                    this.$emit('input', ['', ''])
                }
            }
            if (!this.value) {
                this.$emit('input', '')
            }
            window.addEventListener('click', this.close)
        })
    },
    beforeUnmount() {
        window.removeEventListener('click', this.close)
    },
    methods: {
        messageModalOn: function (message) {
            let that = this
            this.message = message
            this.messageModalShow = true
            window.clearTimeout(this.messageTimeout)
            this.messageTimeout = window.setTimeout(function () {
                that.messageModalOff()
            }, 2000)
        },
        messageModalOff: function () {
            this.messageModalShow = false
        },
        togglePanel() {
            // 選手が未選択（期間が空）の場合は止める
            if (this.inputDate[0] === '' && this.inputDate[1] === '') {
                this.$emit('no-selected-player')
                return false
            }
            this.panelState = !this.panelState
            // カレンダーを表示する際、inputに入っていた値の月を表示
            if (this.panelState) {
                if (this.range === false) {
                    this.tmpYear = Number(this.inputDate.split('年')[0])
                    this.tmpMonth = Number(this.inputDate.split('年')[1].split('月')[0]) - 1
                    this.year = this.tmpYear
                    this.month = this.tmpMonth
                    this.date = Number(this.inputDate.split('年')[1].split('月')[1].split('日')[0])
                    // すでに選択されている年月日をselectedにする
                    this.selectedYear = this.year
                    this.selectedMonth = this.month
                    this.selectedDate = this.date
                } else {
                    if (this.inputDate === '（未選択）') {
                        this.tmpYear = this.maxYear
                        this.tmpMonth = this.maxMonth - 1
                        this.tmpDate = this.maxDate
                    } else {
                        this.tmpYear = Number(this.inputDate[0].split('年')[0])
                        this.tmpMonth = Number(this.inputDate[0].split('年')[1].split('月')[0]) - 1
                    }
                }
            }
            this.rangeStart = false
        },
        isSelected(type, item) {
            switch (type) {
            case 'year':
                if (!this.range) return item === this.tmpYear
                return (new Date(item, 0).getTime() >= new Date(this.tmpStartYear, 0).getTime() && new Date(item, 0).getTime() <= new Date(this.tmpEndYear, 0).getTime())
            case 'month':
                if (!this.range) return item === this.tmpMonth && this.year === this.tmpYear
                return (new Date(this.tmpYear, item).getTime() >= new Date(this.tmpStartYear, this.tmpStartMonth).getTime() && new Date(this.tmpYear, item).getTime() <= new Date(this.tmpEndYear, this.tmpEndMonth).getTime())
            case 'date':
                if (!this.range) {
                    return this.selectedDate === item.value && this.selectedMonth === this.tmpMonth && this.selectedYear === this.tmpYear && item.currentMonth
                    // return this.date === item.value && this.month === this.tmpMonth && this.year === this.tmpYear && item.currentMonth
                }
                let month = this.tmpMonth
                item.previousMonth && month--
                item.nextMonth && month++
                return (new Date(this.tmpYear, month, item.value).getTime() >= new Date(this.tmpStartYear, this.tmpStartMonth, this.tmpStartDate).getTime() && new Date(this.tmpYear, month, item.value).getTime() <= new Date(this.tmpEndYear, this.tmpEndMonth, this.tmpEndDate).getTime())
            }
        },
        chType(type) {
            this.panelType = type
        },
        chYearRange(next) {
            if (next) {
                this.yearList = this.yearList.map((i) => i + 12)
            } else {
                this.yearList = this.yearList.map((i) => i - 12)
            }
        },
        prevMonthPreview() {
            // this.tmpMonth = this.tmpMonth === 0 ? 0 : this.tmpMonth - 1
            // console.log('1つ前の月', this.minYear, this.minMonth, this.tmpYear, this.tmpMonth + 1, this.validateMonth(this.tmpMonth + 1))
            if (this.validateMonth(this.tmpMonth - 1)) return
            this.tmpMonth -= 1
            this.month = this.tmpMonth
            if (this.tmpMonth < 0) {
                if (this.validateYear(this.tmpYear - 1)) {
                    this.tmpMonth = 0
                    this.month = this.tmpMonth
                    return
                }
                this.tmpYear -= 1
                this.year = this.tmpYear
                this.tmpMonth = 11
                this.month = this.tmpMonth
            }
        },
        nextMonthPreview() {
            // console.log('次の月', this.maxYear, this.maxMonth, this.tmpYear, this.tmpMonth + 1, this.validateMonth(this.tmpMonth + 1))
            // this.tmpMonth = this.tmpMonth === 11 ? 11 : this.tmpMonth + 1
            if (this.validateMonth(this.tmpMonth + 1)) return
            this.tmpMonth += 1
            this.month = this.tmpMonth
            if (this.tmpMonth > 11) {
                if (this.validateYear(this.tmpYear + 1)) {
                    this.tmpMonth = 11
                    this.month = this.tmpMonth
                    return
                }
                this.tmpYear += 1
                this.year = this.tmpYear
                this.tmpMonth = 0
                this.month = this.tmpMonth
            }
        },
        selectYear(year) {
            if (this.validateYear(year)) return
            this.tmpYear = year
            this.panelType = 'month'
        },
        selectMonth(month) {
            if (this.validateMonth(month)) return
            this.tmpMonth = month
            this.panelType = 'date'
        },
        selectDate(date) {
            setTimeout(() => {
                if (this.validateDate(date)) return
                if (date.previousMonth) {
                    if (this.tmpMonth === 0) {
                        this.year -= 1
                        this.tmpYear -= 1
                        this.month = this.tmpMonth = 11
                    } else {
                        this.month = this.tmpMonth - 1
                        this.tmpMonth -= 1
                    }
                } else if (date.nextMonth) {
                    if (this.tmpMonth === 11) {
                        this.year += 1
                        this.tmpYear += 1
                        this.month = this.tmpMonth = 0
                    } else {
                        this.month = this.tmpMonth + 1
                        this.tmpMonth += 1
                    }
                }
                if (!this.range) {
                    this.year = this.tmpYear
                    this.selectedYear = this.year
                    this.month = this.tmpMonth
                    this.selectedMonth = this.month
                    this.date = date.value
                    this.selectedDate = this.date
                    if (date.level === 'Bullpen') {
                        this.vsTeam = date.gameList[0].stadium
                    } else {
                        this.vsTeam = date.gameList[0].vsTeam + '戦'
                    }
                    // let value = `${this.tmpYear}-${('0' + (this.month + 1)).slice(-2)}-${('0' + this.date).slice(-2)}`
                    // let value = `${this.tmpYear}年${('0' + (this.tmpMonth + 1)).slice(-2)}月${('0' + date.value).slice(-2)}日`
                    // this.$emit('input', value)
                    // this.panelState = false
                } else if (this.range && !this.rangeStart) {
                    this.tmpEndYear = this.tmpStartYear = this.tmpYear
                    this.tmpEndMonth = this.tmpStartMonth = this.tmpMonth
                    this.tmpEndDate = this.tmpStartDate = date.value
                    this.rangeStart = true
                    this.messageModalOn('検索終了日を選択してください')
                } else if (this.range && this.rangeStart) {
                    this.tmpEndYear = this.tmpYear
                    this.tmpEndMonth = this.tmpMonth
                    this.tmpEndDate = date.value
                    let d1 = new Date(this.tmpStartYear, this.tmpStartMonth, this.tmpStartDate).getTime()
                    let d2 = new Date(this.tmpEndYear, this.tmpEndMonth, this.tmpEndDate).getTime()
                    if (d1 > d2) {
                        let tmpY, tmpM, tmpD
                        tmpY = this.tmpEndYear
                        tmpM = this.tmpEndMonth
                        tmpD = this.tmpEndDate
                        this.tmpEndYear = this.tmpStartYear
                        this.tmpEndMonth = this.tmpStartMonth
                        this.tmpEndDate = this.tmpStartDate
                        this.tmpStartYear = tmpY
                        this.tmpStartMonth = tmpM
                        this.tmpStartDate = tmpD
                    }
                    // let RangeStart = `${this.tmpStartYear}年${('0' + (this.tmpStartMonth + 1)).slice(-2)}月${('0' + this.tmpStartDate).slice(-2)}日`
                    // let RangeEnd = `${this.tmpEndYear}年${('0' + (this.tmpEndMonth + 1)).slice(-2)}月${('0' + this.tmpEndDate).slice(-2)}日`
                    // let value = [RangeStart, RangeEnd]
                    // this.$emit('input', value)
                    this.rangeStart = false
                    this.messageModalOn(this.tmpStartYear + '年' + (this.tmpStartMonth + 1) + '月' + this.tmpStartDate + '日～<br>' + this.tmpEndYear + '年' + (this.tmpEndMonth + 1) + '月' + this.tmpEndDate + '日')
                    // this.panelState = false
                }
            }, 0)
        },
        validateYear(year) {
            if (year > this.maxYear || year < this.minYear) {
                return true
            } else {
                return false
            }
        },
        validateMonth(month) {
            if (new Date(this.tmpYear, month).getTime() >= new Date(this.minYear, this.minMonth - 1).getTime() && new Date(this.tmpYear, month).getTime() <= new Date(this.maxYear, this.maxMonth - 1).getTime()) {
                return false
            }
            return true
        },
        validateDate(date) {
            let mon = this.tmpMonth
            if (date.previousMonth) {
                mon -= 1
            } else if (date.nextMonth) {
                mon += 1
            }
            return !(new Date(this.tmpYear, mon, date.value).getTime() >= new Date(this.minYear, this.minMonth - 1, this.minDate).getTime() && new Date(this.tmpYear, mon, date.value).getTime() <= new Date(this.maxYear, this.maxMonth - 1, this.maxDate).getTime())

        },
        decide(e) {
            if (!this.range) {
                let value = `${this.tmpYear}年${('0' + (this.tmpMonth + 1)).slice(-2)}月${('0' + this.date).slice(-2)}日`
                this.$emit('input', value)
                this.close(e)
            } else {
                if (isNaN(this.tmpStartYear) || this.tmpStartYear === null) return
                let RangeStart = `${this.tmpStartYear}年${('0' + (this.tmpStartMonth + 1)).slice(-2)}月${('0' + this.tmpStartDate).slice(-2)}日`
                let RangeEnd = `${this.tmpEndYear}年${('0' + (this.tmpEndMonth + 1)).slice(-2)}月${('0' + this.tmpEndDate).slice(-2)}日`
                let value = [RangeStart, RangeEnd]
                this.$emit('input', value)
                this.close(e)
            }
        },
        close(e) {
            e.stopPropagation()
            if (!this.$el.contains(e.target) || e.target.id === 'btnDecide' || e.target.id === 'btnClose' || e.target.id === 'layerClose') {
                this.panelState = false
                this.rangeStart = false
                if (this.range) {
                    this.tmpStartYear = null
                    this.tmpStartMonth = null
                    this.tmpStartDate = null
                    this.tmpEndYear = null
                    this.tmpEndMonth = null
                    this.tmpEndDate = null
                }
            }
        },
        clear() {
            // this.$emit('input', this.range ? ['', ''] : '')
            this.$emit('input', this.range ? '（未選択）' : '')
            if (this.range) {
                this.tmpStartYear = null
                this.tmpStartMonth = null
                this.tmpStartDate = null
                this.tmpEndYear = null
                this.tmpEndMonth = null
                this.tmpEndDate = null
            }
        }
    }
}
</script>
